<template>
  <section id="mainContent">
    <general-header :headerTitle="$t('Termos de uso')" :headerIcon="['document-text-outline']"></general-header>
      <left-menu></left-menu>
      <div class="termsOfUse" v-if="!loading">
        <div class="termsOfUse__content">
            <div class="termsOfUse__content-title">
              {{ $t('Termos de uso') }}
            </div>
            <iframe class="termsOfUse__content-body"  frameBorder="0" :src="termsOfUse"></iframe>
        </div>
      </div>

      <dot-loader v-if="loading"></dot-loader>
  </section>
</template>

<script>
import { CHECK_TERMS_OF_USE } from '../../../../urlConfig';
import GeneralHeader from '../../components/layouts/generalHeader.vue';
import leftMenu from '../../components/leftMenu.vue';
import axios from 'axios';
import dotLoader from '../../components/dotLoader.vue';

export default {
  name: 'termsOfUse',
  components: {
    leftMenu,
    GeneralHeader,
    dotLoader
  },
  data() {
    return {
      show: true,
      url: null,
      termsOfUse: null,
      loading: false,
    }
  },
  methods: {
    async acceptTerms() {
      this.$emit('accept');
      this.closeModal();
    },

    async rejectTerms() {
      this.$emit('reject');
      this.closeModal();
    },

    closeModal() {
      this.show = false;
      this.$emit('close');
    },
    async getTermsOfUse() {
      this.loading = true
      const token = JSON.parse(localStorage.getItem('authUser')).v2Token;
      await axios.get(CHECK_TERMS_OF_USE, {
        headers: {
          'Authorization': `Bearer ${token}`,
          companyId: JSON.parse(localStorage.getItem('userInfo')).companyId
        }
      }).then((response)  => {
        this.termsOfUse = response.data.url + "#toolbar=0";
        this.loading = false
      }).catch((err) => {
        this.loading = false
      })

      this.loading = false
    }
  },
  beforeMount() {
    this.getTermsOfUse()
  }
}
</script>

<style lang="scss">
  .termsOfUse {
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    margin-right: 47px;
    width: calc(100% - 47px);
    border-radius: 20px;
    border: 1px solid #EBEBEB;
    background: #FFF;
    box-shadow: 60px 60px 24px 0px rgba(0, 0, 0, 0.00), 39px 38px 22px 0px rgba(0, 0, 0, 0.01), 22px 22px 18px 0px rgba(0, 0, 0, 0.04), 10px 10px 14px 0px rgba(0, 0, 0, 0.06), 2px 2px 7px 0px rgba(0, 0, 0, 0.07), 0px 0px 0px 0px rgba(0, 0, 0, 0.07);
  }

  .termsOfUse__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    gap: 32px;
  }

  .termsOfUse__content-title {
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 125.303%;
    color: #3A424E
  }

  .termsOfUse__content-body {
    max-width: 1100px;
    min-height: 600px;
    width: 800px;
  }

  .termsOfUse__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    button:nth-child(1) {
      color: #3A424E80;
      display: flex;
      padding: 6px 16px;
      font-weight: 600;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      border: none;
      background-color: transparent;
    }

    button:nth-child(2) {
      color: #1b59f8;
      display: flex;
      padding: 6px 16px;
      font-weight: 600;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      border: none;
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/termsOfUse/TermsOfUse.vue